<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Rutas</h3>
            </div>
            <div class="col-6 text-right">
              <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                <span class="btn-inner--icon"
                  ><i class="fas fa-plus"></i
                ></span>
                <span class="btn-inner--text">Ruta</span>
              </base-button>
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
          <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Datos por página"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item.value"
                :label="item.descripcion"
                :value="Number(item.value)"
              >
              </el-option>
          </el-select>

            <div>
              <form class="apolo-borde">
                <base-input
                  v-model="query"
                  type="search"
                  append-icon="fas fa-search"
                  placeholder="Buscar..."
                  clearable
                  inputClasses="apolo-borde"
                />
              </form>
            </div>

            <el-select
              class="select-primary pagination-select"
              v-model="status"
              placeholder="Seleccionar status"
              clearable
            >
              <el-option
                class="select-primary"
                label="Activo/Inactivo"
                value="Activo/Inactivo"
              >
              </el-option>
              <el-option
                class="select-primary"
                label="Activo"
                value="Activo"
              >
              </el-option>
              <el-option
                class="select-primary"
                label="Inactivo"
                value="Inactivo"
              >
              </el-option>
            </el-select>
          </div>
          <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="rutas"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <div slot="empty" v-if="rutas">
              Sin datos disponibles
            </div>

            <el-table-column label="Nombre" prop="attributes.nombre" />
            <el-table-column label="Terminal Origen" prop="relationships.terminal_origen.nombre" />
            <el-table-column label="Terminal Destino" prop="relationships.terminal_destino.nombre" />
            <el-table-column label="Linea" prop="attributes.nombre_linea" />
            <el-table-column label="Tramos" prop="relationships.tramos_count" />
            <el-table-column label="Usado en corridas">
                <div slot-scope="{ row }" class="table-actions">
                  <span v-if="row.attributes.usado_en_corridas == 0">No</span>
                  <span v-else>Si</span>
                </div>
            </el-table-column>
            <el-table-column align="center">
              <div slot-scope="{ row }" class="table-actions">
                <base-button class="hover-apolo" type="primary" icon size="sm" @click="editRuta(row)">
                  <span class="btn-inner--text">Editar</span>
                </base-button>
                <base-button class="hover-apolo" type="primary" icon size="sm" @click="editRutaTramos(row)">
                  <span class="btn-inner--text">Tramos</span>
                </base-button>
                <base-button v-if="row.attributes.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateRuta(row)">
                  <span class="btn-inner--text">Desactivar</span>
                </base-button>
                <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateRuta(row)">
                  <span class="btn-inner--text">Activar</span>
                </base-button>
              </div>
          </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center flex-wrap"
        >
          <base-pagination
            class="pagination-no-border justify-content-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </div>
      </card>
    </div>
    <!-- MODAL CREATE -->
    <modal :show.sync="showAddModal" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Crear ruta</h6>
      <form class="new-event--form" @submit.prevent="addRuta">
        <base-input label="Nombre"
                    placeholder="Nombre"
                    v-model="ruta.nombre"
                    input-classes="form-control-alternative new-event--title">
        </base-input>
        <validation-error :errors="apiValidationErrors.nombre" />
        <base-input label="Terminal de origen">
          <multiselect id="ruta_select_origen" v-model="ruta.terminal_origen" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de origen" label="nombre" track-by="id" :showLabels="false"></multiselect>
        </base-input>
        <validation-error :errors="apiValidationErrors.terminal_origen_id" />
        <base-input label="Terminal de destino">
          <multiselect id="ruta_select_destino" v-model="ruta.terminal_destino" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de destino" label="nombre" track-by="id" :showLabels="false"></multiselect>
        </base-input>
        <validation-error :errors="apiValidationErrors.terminal_destino_id" />
        <base-input label="Linea">
          <div v-for="linea in lineas">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" @click="selectedLine(linea.id)">
              <label class="form-check-label" for="exampleRadios1">
                {{ linea.nombre }}
              </label>
            </div>
          </div>
        </base-input>
        <span v-if="validacion.mensaje != null">
          <small class="argon-error" v-text="validacion.mensaje"/>
        </span>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>

      <template slot="footer">
        <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addRuta">Guardar</button>
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
      </template>
    </modal>
    <!-- MODAL EDIT -->
    <modal :show.sync="showEditModal" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Editar ruta</h6>
      <form class="new-event--form" @submit.prevent="editRuta">
        <base-input label="Nombre"
                    placeholder="Nombre"
                    v-model="ruta.nombre"
                    input-classes="form-control-alternative new-event--title">
        </base-input>
        <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Terminal de origen">
              <multiselect disabled v-model="ruta.terminal_origen" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de origen" label="nombre" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.terminal_origen" />
          <base-input label="Terminal de destino">
              <multiselect disabled v-model="ruta.terminal_destino" :options="terminales" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione terminal de destino" label="nombre" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.terminal_destino" />
          <base-input label="Linea">
            <div v-for="linea in lineas">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" @click="selectedLine(linea.id)" :checked="linea.id == ruta.linea">
                <label class="form-check-label" for="exampleRadios1">
                  {{ linea.nombre }}
                </label>
              </div>
            </div>
          </base-input>
          <span v-if="validacion.mensaje != null">
            <small class="argon-error" v-text="validacion.mensaje"/>
          </span>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
      </form>

      <template slot="footer">
        <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateRuta">Actualizar</button>
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
      </template>
    </modal>
    <!-- MODAL TRAMOS -->
    <modal :show.sync="showRutaTramoModal" modal-classes="modal-primary" size="lg">
      <h6 slot="header" class="mb-0 modal-title">Tramos de ruta {{ruta_tramo.ruta_nombre}}</h6>
      <form class="new-event--form" @submit.prevent="addTramoRuta">
        <base-input label="Seleccionar tramo">
          <multiselect v-model="ruta_tramo.tramo" :options="tramos_active" :custom-label="({ origen, destino }) => `${origen} / ${destino}`" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione un tramo" label="origen" track-by="id" :showLabels="false"></multiselect>
        </base-input>
        <validation-error :errors="apiValidationErrors.tramo" />
        <validation-error :errors="apiValidationErrors.tramo_id" />
        <div class="row">
          <div class="col-8">
            <base-input 
                    placeholder="Tiempo en minutos desde terminal origen de tramo a origen de ruta"
                    v-model="ruta_tramo.tiempo_ruta_tramo"
                    input-classes="form-control-alternative new-event--title">
            </base-input>
            <validation-error :errors="apiValidationErrors.tiempo_ruta_tramo" />
          </div>
          <div class="col-4">
            <button type="submit" class="btn btn-default hover-apolo new-event--add ml-auto">Agregar Tramo a Ruta</button>
          </div>
        </div>
      </form>
        <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="ruta_tramos"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <div slot="empty" v-if="ruta_tramos">
              Sin datos disponibles
            </div>

            <el-table-column label="Terminal Origen" prop="tramo.terminal_origen.nombre" />
            <el-table-column label="Terminal Destino" prop="tramo.terminal_destino.nombre" />
            <el-table-column label="Tiempo Tramo" prop="tramo.tiempo" />
            <el-table-column label="Tiempo Origen" prop="tiempo_ruta_tramo" />
            <el-table-column align="center">
              <div slot-scope="{ row }" class="table-actions">
                <base-button v-if="row.ruta.usado_en_corridas === 0" class="hover-apolo" type="primary" icon size="sm" @click="deleteRutaTramo(row)">
                  <span class="btn-inner--text">Eliminar</span>
                </base-button>
              </div>
          </el-table-column>
        </el-table>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>

      <template slot="footer">
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeRutaTramoModal">Cerrar</button>
      </template>
    </modal>
  </div>
</template>
<script>
import { BasePagination, Modal } from "@/components/";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import Multiselect from 'vue-multiselect'
import ButtonRadioGroup from "@/components/ButtonRadioGroup.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ValidationError,
    Multiselect,
    Modal,
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    ButtonRadioGroup
  },

  mixins: [formMixin],

  data() {
    return {
      rutas: [],
      terminales: [],
      tramos_active: [],
      ruta_tramos: [],
      selectedRows: [],
      query: null,
      status: null,
      validacion: {},

      sort: "created_at",

      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [{value:'5', descripcion: '5 rutas por página'},
        {value:'10', descripcion: '10 rutas por página'},
        {value:'25', descripcion: '25 rutas por página'},
        {value:'50', descripcion: '50 rutas por página'}],
      },
      total: 0,
      loading: true,
      showAddModal: false,
      showEditModal: false,
      showRutaTramoModal: false,
      ruta: {
        type: "rutas",
        nombre: null,
        terminal_origen: null,
        terminal_destino: null,
        linea: null
      },
      lineas: [
        {value: "1", label: "Apolo Platinum"},
        {value: "2", label: "Platinum Line"} 
      ],
      ruta_tramo: {
        type: "Ruta Tramos",
        ruta_id: null,
        ruta_nombre: null,
        tramo: null,
        tiempo_ruta_tramo: null
      }
    };
  },

  mounted(){
    this.getTerminales();
    this.getLineas();
    this.getTramosActive(); 
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    status: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    }
  },

  methods: {
    selectedLine(linea){
      this.ruta.linea = linea;
    },
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { search: this.query } : {}),
          ...(this.status ? { status: this.status } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      await this.$store.dispatch("rutas/list", params).then(() => {
        this.rutas = this.$store.getters["rutas/list"];
        this.total = this.$store.getters["rutas/listTotal"];
      });
      this.loading = false;
    },

    async getLineas() {
      let params = {
        filter: {
        },
        page: {
          number: 1,
          size: 100000,
        },
      };
      await this.$store.dispatch("rutas/line", params).then(() => {
        this.lineas = this.$store.getters["rutas/line"];
      });
    },

    async getTerminales() {
      let params = {
        filter: {
        },
        page: {
          number: 1,
          size: 100000,
        },
      };
      await this.$store.dispatch("terminales/list", params).then(() => {
        this.terminales = this.$store.getters["terminales/list"];
      });
    },

    async getTramosActive() {
      let params = {
        filter: {
        },
        page: {
          number: 1,
          size: 100000,
        },
      };
      await this.$store.dispatch("tramos/listActive", params).then(() => {
        this.tramos_active = this.$store.getters["tramos/listActive"];
      });
    },

    async getRutaTramos($id) {
      await this.$store.dispatch("rutas/listRutaTramos", $id).then(() => {
        this.ruta_tramos = this.$store.getters["rutas/listRutaTramos"];
      });
    },

    closeModal() {
      this.resetApiValidation();
      this.validacion = {};
      if(this.showAddModal == true){
        this.showAddModal = false;
      }else{
        this.showEditModal = false;
      }
      this.ruta.nombre = null;
      this.ruta.terminal_origen = null;
      this.ruta.terminal_destino = null;
      this.ruta.linea = null;
    },

    closeRutaTramoModal(){
      this.showRutaTramoModal = false;
      this.ruta_tramo.ruta_id = null;
      this.ruta_tramo.ruta_nombre = null;
      this.ruta_tramo.tramo = null;
      this.ruta_tramo.tiempo_ruta_tramo = null;
    },

    async addRuta(){
      try {
        await this.$store.dispatch("rutas/add", this.ruta);

        this.$notify({
          type: "success",
          message: "Ruta creada satisfactoriamente.",
          duration: -1
        });
        this.validacion = {};
        this.getList();
        this.closeModal();
      } catch (error) {
        if(error.response.data.errors.detail){
          this.$notify({
                type: "danger",
                message: error.response.data.errors.detail,
                duration: -1
            });
        }
        else if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
        this.resetApiValidation();
        this.validacion = {};
        if(error.response.data.errors){
          this.setApiValidation(error.response.data.errors);
        }else{
          this.validacion.mensaje = error.response.data.message;
        }
        
      }
    },

    async addTramoRuta(){
      try {
      await this.$store.dispatch("rutas/addTramo", this.ruta_tramo);

      this.$notify({
        type: "success",
        message: "Tramo agregado a ruta satisfactoriamente.",
        duration: -1
      });
      this.resetApiValidation();
      this.ruta_tramo.tramo = null;
      this.ruta_tramo.tiempo_ruta_tramo = null;
      this.getRutaTramos(this.ruta_tramo.ruta_id);
      } catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
        this.resetApiValidation();
        this.setApiValidation(error.response.data.errors);
      }
    },

    editRutaTramos(row) {
      this.resetApiValidation();
      this.getRutaTramos(row.id);
      this.ruta_tramo.ruta_id = row.id;
      this.ruta_tramo.ruta_nombre = row.attributes.nombre;
      this.showRutaTramoModal = true;
    },

    async deleteRutaTramo(row){
      const confirmation = await swal.fire({
        title: `¿Deseas eliminar este tramo de la ruta?`,
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-lg btn-default hover-apolo",
        cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
      });

      try {
        if (confirmation.value === true) {
            await this.$store.dispatch("rutas/destroyTramo", row.id);
            await this.getRutaTramos(row.ruta_id);
            this.$notify({
            type: "success",
            message: "Tramo eliminado de ruta satisfactoriamente.",
            duration: -1
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
      }
    },

    editRuta(row) {
      this.resetApiValidation();
      this.showEditModal = true;
      this.ruta.nombre = row.attributes.nombre;
      this.ruta.terminal_origen = this.terminales.find(item => item.id == row.relationships.terminal_origen.id);
      this.ruta.terminal_destino = this.terminales.find(item => item.id == row.relationships.terminal_destino.id);
      this.ruta.linea = row.attributes.linea;
      this.ruta.id = row.id;
    },

    async updateRuta() {
      try{
        await this.$store.dispatch("rutas/update", this.ruta);
        this.$notify({
          type: "success",
          message: "Ruta actualizada satisfactoriamente.",
          duration: -1
        });
        this.validacion = {};
        this.getList();
        this.closeModal();
      } catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
        this.validacion = {};
        this.resetApiValidation();
        if(error.response.data.errors){
          this.$notify({
              type: "danger",
              message: error.response.data.errors[0].detail,
              duration: -1
          });
          this.setApiValidation(error.response.data.errors);
        }else{
          this.validacion.mensaje = error.response.data.message;
        }
      }
    },

    async activateRuta(row) {
      const confirmation = await swal.fire({
        title: `¿Desea activar este ruta?`,
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Activar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-lg btn-default hover-apolo",
        cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
      });

      try {
        if (confirmation.value === true) {
            await this.$store.dispatch("rutas/activate", row.id);
            await this.getList();
            this.$notify({
            type: "success",
            message: "Ruta activada satisfactoriamente.",
            duration: -1
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
      }
    },

    async deactivateRuta(row) {
      const confirmation = await swal.fire({
        title: `¿Desea desactivar este ruta?`,
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Desactivar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-lg btn-default hover-apolo",
        cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
      });

      try {
        if (confirmation.value === true) {
            await this.$store.dispatch("rutas/deactivate", row.id);
            await this.getList();
            this.$notify({
            type: "success",
            message: "Tramo desactivado satisfactoriamente.",
            duration: -1
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
      }
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
<style lang="scss">
 .argon-error {
   position: relative;
   bottom: 25px !important;
   color: #fb6340;
   }
</style>